// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"157":"ccdeadb6","189":"e199ff38"}[chunkId] + ".css";
};